export const visualElementStore = new WeakMap();
//# sourceMappingURL=store.js.map